import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="has-advance"
export default class extends Controller {
  static targets = [ "advance_amount", "advance_consumed_amount", "advance_active", "has_advance" ]

  connect() {
    // Para establecer inicialmente el estado de los campos
    this.toggleBasedOnAdvanceState();
    this.updateAdvanceActiveState();
  }

  toggle(event) {
    this.toggleBasedOnAdvanceState();
    this.updateAdvanceActiveState();
  }

  toggleBasedOnAdvanceState() {
    const isChecked = this.has_advanceTarget.checked;
    this.toggleDisabledState(this.advance_amountTarget, isChecked);
    this.toggleDisabledState(this.advance_consumed_amountTarget, isChecked);
    this.advance_activeTarget.disabled = true;
  }

  updateAdvanceActiveState() {
    const advanceAmount = parseFloat(this.advance_amountTarget.value);
    const advanceConsumedAmount = parseFloat(this.advance_consumed_amountTarget.value);
    this.advance_activeTarget.checked = advanceAmount > advanceConsumedAmount;
  }

  toggleDisabledState(target, isChecked) {
    target.disabled = !isChecked;
    if (isChecked) {
      target.classList.remove('bg-gray-200', 'cursor-not-allowed');
    } else {
      target.classList.add('bg-gray-200', 'cursor-not-allowed');
      if (target.type === "checkbox") {
        target.checked = false;
      }
      else if (target.type === "number" || target.type === "text") {
        target.value = "";
      }
    }
  }
}
